var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E4E4E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12C18.5 15.5899 15.5899 18.5 12 18.5C8.41015 18.5 5.5 15.5899 5.5 12C5.5 8.41015 8.41015 5.5 12 5.5C15.5899 5.5 18.5 8.41015 18.5 12Z",
    stroke: "#1B1625"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8023 8.90562C13.8023 9.90102 12.9954 10.708 12 10.708C11.0046 10.708 10.1976 9.90102 10.1976 8.90562C10.1976 7.91021 11.0046 7.10327 12 7.10327C12.9954 7.10327 13.8023 7.91021 13.8023 8.90562Z",
    stroke: "#1B1625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72179 14.4444L8.72179 14.4444C8.93023 15.1523 9.3622 15.7737 9.9531 16.2157C10.544 16.6577 11.2621 16.8965 12 16.8966L8.72179 14.4444ZM8.72179 14.4444C8.40372 13.3642 9.21356 12.2812 10.3394 12.2812H13.6606C14.7866 12.2812 15.5963 13.3638 15.2782 14.4438L15.2782 14.4439M8.72179 14.4444L15.2782 14.4439M15.2782 14.4439C15.0698 15.1519 14.6379 15.7734 14.047 16.2155M15.2782 14.4439L14.047 16.2155M14.047 16.2155C13.4561 16.6576 12.738 16.8965 12 16.8966L14.047 16.2155Z",
    stroke: "#1B1625"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.3a3331722605027bd99c6b9f38a10681.svg";
export { ForwardRef as ReactComponent };